import { createSlice, type PayloadAction } from '@reduxjs/toolkit';

interface PopupState {
  isVisible: boolean;
  popupId: string;
}

const initialState: PopupState = {
  isVisible: false,
  popupId: '',
};

export const popupSlice = createSlice({
  name: 'popup',
  initialState,
  reducers: {
    showPopup(state, action: PayloadAction<string>) {
      state.isVisible = true;
      state.popupId = action.payload;
    },
    hidePopup(state) {
      state.isVisible = false;
      state.popupId = '';
    },
  },
});

export const { showPopup, hidePopup } = popupSlice.actions;
